// extracted by mini-css-extract-plugin
module.exports = {"links":"Ubn1f","row":"ZI8iH","column":"gQFpL"};